import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';

const PicModal = ({ setClockinPicModal,isoldbuild, selectedItem }) => {
  console.log(selectedItem,'selectedItem');
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative w-[40%] md:w-[40%] bg-white rounded-lg text-start border border-gray-300 shadow-sm">
        <div className="flex border-b py-2 px-6 justify-between items-center">
          <p className="font-poppins font-semibold text-[22px]">Employee Picture</p>
          <button
            onClick={() => setClockinPicModal(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="flex w-full items-center justify-around p-6">
          {/* Clock-in Section */}
        <div>
  <p className="text-lg font-medium text-center mb-1">Clock-in:</p>
  <div className="w-[200px] h-[120px] overflow-hidden flex items-center justify-center bg-gray-100 border rounded">
    {selectedItem?.clockin_pic ? (
      <img
        src={`https://hub2.ntactops.com/ntact/files/pictures/${selectedItem.clockin_pic}`}
        alt="Clock-in Employee"
        className="max-w-full max-h-full object-cover"
        onError={(e) => {
          e.currentTarget.src = `https://hub.ntactops.com/api/storage/logs/pictures/${selectedItem.clockin_pic}`;
        }}
      />
    ) : (
      <span className="text-gray-500">Image Not available</span>
    )}
  </div>

  <div className="text-xl text-green-500 text-center font-inter mb-1 font-bold">
    {/* {selectedItem?.clock_in
      ? new Date(selectedItem.clock_in).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        })
      : '--'} */}
 {
  selectedItem?.clockin_pic_time
    ? (
     isoldbuild
          ? dayjs(
              dayjs.utc(selectedItem.clockin_pic_time)
                .tz("America/Regina")
                .format("YYYY-MM-DDTHH:mm:ss")
            ) .add(1, "hour").format("hh:mm A")
          : dayjs(selectedItem.clockin_pic_time).format("hh:mm A")
      )
    : "--"
}

  </div>

  {selectedItem?.cintype && (
<div className="flex justify-center mt-2">
  <div
    className={`inline-block px-4 py-1.5 rounded-full font-roboto text-sm tracking-wide bg-[#E0F2FF] text-[#0B61A4]
    `}
  >
{selectedItem.cintype?.toLowerCase() === 'face'
  ? 'Facial Recognition'
  : selectedItem.cintype?.toLowerCase() === 'manual'
  ? 'Manual Capture'
  : selectedItem.cintype}

  </div>
</div>


  )}
</div>


          {/* Clock-out Section */}
          <div>
            <p className="text-lg text-center font-medium mb-1">Clock-out:</p>
            <div className="w-[200px] h-[120px] overflow-hidden flex items-center justify-center bg-gray-100 border rounded">
              {selectedItem?.clockout_pic ? (
                <img
                  src={`https://hub2.ntactops.com/ntact/files/pictures/${selectedItem.clockout_pic}`}
                  alt="Clock-out Employee"
                  className="max-w-full max-h-full object-cover"
                  onError={(e) => {
                    e.currentTarget.src = `https://hub.ntactops.com/api/storage/logs/pictures/${selectedItem.clockout_pic}`;
                  }}
                />
              ) : (
                <span className="text-gray-500">Image Not available</span>
              )}
            </div>
            <div className="text-xl text-green-500 text-center font-inter mb-1 font-bold">
              {/* {selectedItem?.clock_out
                ? new Date(selectedItem.clock_out).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  })
                : '--'} */}
{
  selectedItem?.clockout_pic_time
    ? (
      isoldbuild
          ? dayjs(
              dayjs.utc(selectedItem.clockout_pic_time)
                .tz("America/Regina")
                .format("YYYY-MM-DDTHH:mm:ss")
            ) .add(1, "hour").format("hh:mm A")
          : dayjs(selectedItem.clockout_pic_time).format("hh:mm A")
      )
    : "--"
}

            </div>
            {/* {selectedItem?.couttype && (
              <div className="text-center text-gray-700 font-medium">{selectedItem.couttype}</div>
            )} */}
             {selectedItem?.couttype && (
<div className="flex justify-center mt-2">
  <div
    className={`inline-block px-4 py-1.5 rounded-full font-roboto text-sm tracking-wide
     bg-[#E0F2FF] text-[#0B61A4]  `}
  >
    {selectedItem.couttype?.toLowerCase() === 'face'
  ? 'Facial Recognition'
  : selectedItem.couttype?.toLowerCase() === 'manual'
  ? 'Manual Capture'
  : selectedItem.couttype}

  </div>
</div>


  )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PicModal;
